module.exports = __webpack_public_path__ + "media/images/digivent/avatars/AVATAR-20-392708907545a1bb83fae919de971d79.png";